export default function AppSection() {
  return (
    <section id="app" className="w-full py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60">
          <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-50 flex-shrink-0">
            <i className="ri-smartphone-line text-2xl text-primary-600"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
              51吃瓜网址移动端入口
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed">
              手机浏览器直接访问51吃瓜网址最新入口，无需下载APP，适配所有移动设备。
              随时随地追最新爆料、看热播剧综吐槽，防走失域名自动跳转，确保移动端访问同样流畅稳定。
            </p>
          </div>
          <a
            href="#carousel"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap flex-shrink-0 cursor-pointer"
          >
            立即访问 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}